// extracted by mini-css-extract-plugin
export default {"container":"Us_container__Oe4J0","text":"Us_text__ieSis","column":"Us_column__+9K9I","icons":"Us_icons__nBAL6","pulse":"Us_pulse__7oAWe"};